import styled from 'styled-components'

interface RequireProps {
    show: boolean
}
const Require = styled.b<RequireProps>`
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    display: inline-block;
    color: ${({ show }) => (show ? '#c43535' : 'transparent')};
    transition: all 0.2s;
    &::before {
        content: '*';
    }
`

export { Require, RequireProps }
